<template>
  <div>
    <div v-if="item.status === 'DRAFT'" class="empty-participant-message">
      <i class="fa fa-users big-icon"></i>
      <p class="info-text">Deltagarlistan kommer synas när evenemanget har publicerats.</p>
    </div>
    <div v-else>


      <memlist-modal size="lg" ref="sendout-modal">

        <m-row>
          <m-col lg="12">
            <memlist-text-input
              id="from_name"
              name="from_name"
              :title="$t('PAGES.SENDOUT.FROM_NAME')"
              layout="vertical"
              v-model="message.from_name"
              :required="true"
            />
          </m-col>
        </m-row>

        <m-row>
          <m-col lg="12">
            <memlist-text-input
              id="from_email"
              name="from_email"
              :title="$t('PAGES.SENDOUT.SENDER')"
              layout="vertical"
              v-model="message.from_email"
              :required="true"
            />
            <p>{{ $t('EVENT.SENDER_EMAIL_INFO') }}</p>
          </m-col>
        </m-row>


        <m-row>
          <m-col lg="12">
            <memlist-text-input
              id="subject"
              name="subject"
              :title="$t('EVENT.MESSAGE_SUBJECT')"
              layout="vertical"
              v-model="message.subject"
              :required="true"
            />
          </m-col>
        </m-row>

        <m-row>
          <m-col lg="12">
            <memlist-textarea
              id="text"
              name="text"
              rows="10"
              :title="$t('EVENT.MESSAGE_TEXT')"
              layout="vertical"
              v-model="message.text"
              :required="true"
            />
          </m-col>
        </m-row>
        
        <m-row>
          <m-col lg="12">
            <div class="mt-4 d-flex justify-end">
              <memlist-icon-button
              icon="menu-icon flaticon2-email"
              :text="$t('EVENT.SEND_TO_PARTICIPANTS')"
              variant="primary"
              @click="on_open_confirm"
            />
            </div>
          </m-col>
        </m-row>

      </memlist-modal>


      <SuccessPopup
        :header="$t('COMMON.SUCCESS')"
        :text="$t('EVENT.MESSAGE_SENT')"
        :autoshow="false"
        ref="success-popup"
      />

      <Confirm
        :title="$t('COMMON.CONFIRM')"
        :message="$t('EVENT.CONFIRM_SENDOUT')"
        ref="confirm-sendout"
        type="success"
        @confirm="on_confirmed_sendout"
      />
    
      <MemberEditorCompactModal
        ref="member-editor-compact-modal"
        :member_id="member_id"

      />

      <PersonEditorModal
        ref="person-modal"
        :person_id="person_id"
      />

      
      <MemberEventEditorModalV2
        :event="item"
        :item="member_event"
        ref="member-event-editor-modal"
        @updated="updated_member_event"
        @created="created_member_event"
      />
      <form @submit.prevent="save_event" class="mt-8">

        <m-row class="mb-4">

          <m-col cols="12">
            <div class="d-flex justify-end flex-wrap gap-2">
              <memlist-icon-button
                icon="menu-icon flaticon2-email"
                :text="$t('EVENT.SEND_TO_PARTICIPANTS')"
                variant="primary"
                @click="open_send_to_participants"
              />
              
              <memlist-icon-button
                icon="menu-icon flaticon2-plus"
                class="ml-2"
                :text="$t('EVENT.ADD_PARTICIPANT')"
                variant="primary"
                @click="create_member_event_clicked"
              />

              <memlist-icon-button
                class="ml-2"
                icon="menu-icon flaticon2-file"
                :text="$t('COMMON.EXPORT_XLSX')"
                variant="primary"
                @click="export_xlsx_clicked"
              />
            </div>
          </m-col>
          </m-row>
          <m-row>
          <m-col lg="6" class="mb-4 mb-lg-0 pr-lg-4">
            <memlist-text-input
              id="filter-input"
              name="filter-input"
              layout="vertical"
              :placeholder="$t('EVENT.SEARCH_NAME')"
              v-model="textFilter"
            />
          </m-col>

          <m-col lg="6" class="mb-4 mb-lg-0 pl-lg-4">
            <Multiselect
              style="height: 48px;"
              class="multiselect-blue"
              v-model="filter_tickets"
              ref="tickets_multiselect"
              mode="tags"
              :placeholder="$t('EVENT.SELECT_TICKETS')"
              :close-on-select="false"
              @input="tickets_changed"
              :options="ticket_options"
            />
          </m-col>

        </m-row>

      </form>


      <memlist-static-table
        id="member-events-table"
        style="width: 100%; table-layout: fixed;"
        class="table-striped mt-4"
        :fields="event_headers"
        :items="member_events"
        head-variant="light"
        ref="member-events-table"
      >
        <template #cell(actions)="data">

          <div class='d-flex justify-content-end'>
            <memlist-table-button class="mr-2" @click="member_selected(data.item)" icon="fa fa-user" :tooltip="$t('MEMBER_EDITOR.SHOW')" />
            <memlist-table-button class="mr-2" @click="edit_member_event_clicked(data.item)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')" />
            <memlist-table-button @click="delete_member_event_clicked(data.item)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />
          </div>
        </template>

      </memlist-static-table>

      <Confirm
        :title="$t('EVENT.REMOVE_PARTICIPANT')"
        :message="$t('EVENT.REMOVE_PARTICIPANT_TEXT')"
        ref="delete-member-event"
        :type="'success'"
        :confirm="$t('COMMON.YES')"
        :cancel="$t('COMMON.NO')"
        @confirm="delete_member_event"
      />
    </div>
  </div>
</template>

<script>
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import MemberEventEditorModalV2 from '@/view/pages/ml/events/MemberEventEditorModalV2.vue';
import Multiselect from '@vueform/multiselect/dist/multiselect.vue2.js'
import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import SuccessPopup from '@/view/components/SuccessPopup.vue';


export default {
  name: 'EventFormParticipants',
  props: ['item'],
  components: {
    MemberEventEditorModalV2,
    Multiselect,
    SuccessPopup
  },
  mixins: [ toasts ],
  watch: {
    
    filter_tickets: {
      deep: true,
      handler(val) {
        
        this.load_participants(this.local_item.event_id, val);
        
      },
      immediate: true
    },
    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_item = { ...this.item };

        this.load_tickets(this.local_item.event_id);
        this.load_participants(this.local_item.event_id);
      },
      immediate: true
    },
  },
  data() {
    return {
      textFilter: null,
      person: {},
      message: {},
      member_id: null,
      person_id: null,
      ticket_options: [],
      filter_tickets: [],
      event_headers: [
        {
          key: 'ts_signup',
          label: this.$t('COMMON.DATE'),
          sortable: true,
          thClass: 'td-short2',
          tdClass: 'td-short2',
          
          formatter: (_, __, item) => {
            return dayjs(item.ts_signup).format('YYYY-MM-DD HH:mm');
          },
        },
        {
          key: 'company',
          label: this.$t('MEMBER.COMPANY_NAME'),
          thClass: 'td-short2',
          tdClass: 'td-short2',
        },
        
        {
          key: 'checkedin',
          label: this.$t('EVENT.CHECKEDIN'),
          thClass: 'td-short',
          tdClass: 'td-short',
          sortable: false,
          formatter: (_, __, item) => {
            return item.checkedin ? this.$t('COMMON.YES') : this.$t('COMMON.NO')
          },
        },
        {
          key: 'firstname',
          label: this.$t('COMMON.NAME'),
          thClass: 'td-short2',
          tdClass: 'td-short2',
          formatter: (_, __, item) => {

            const m = item.person !== null && item.person !== undefined ? item.person : item.member;

            if (m.cname) {
              return m.cname + ' ' + m.firstname + ' ' + m.lastname;
            }

            return m.firstname + ' ' + m.lastname;
          },
          sortable: false
        },
        {
          key: 'email',
          thClass: 'td-short2',
          tdClass: 'td-short2',
          label: this.$t('MEMBER.EMAIL'),
          formatter: (_, __, item) => {

            const m = item.person !== null && item.person !== undefined ? item.person : item.member;

            if (m.email) {
              return m.email;
            }

            return '';
          },
        },
        
        {
          key: 'actions',
          tdClass: 'td-short',
          thClass: 'td-short',
          label: this.$t('COMMON.ACTIONS')
        }
      ],
      member_event_to_delete: null,
      member_event: null,
      member_event_id: null,
      member_events: [],
      local_item: {}
    }
  },
  methods: {

    on_open_confirm() {
      this.$refs['confirm-sendout'].show();
    },

    async on_confirmed_sendout() {
      const res = await axios.post(`/events/sendout`, { text: this.message.text, subject: this.message.subject, event_id: this.item.event_id, from_name: this.message.from_name, from_email: this.message.from_email });

      if (res.status === 201) {
        this.$refs['success-popup'].show();

        this.$refs['sendout-modal'].hide();
      }
      else {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.UNABLE_SEND_MESSAGE'));
      }
    },

    open_send_to_participants() {
      this.$refs['sendout-modal'].show();
    },

    member_selected(member) {

      if (member.member_id) {
        this.member_id = member.member_id;
        this.$nextTick(()=>{
          this.$refs['member-editor-compact-modal'].show();
        });
      }
      else {
        this.person = member.person;
        this.person_id = member.person_id;
        this.$nextTick(()=>{
          this.$refs['person-modal'].show();
        });       
      }

    },

    updated_member_event(member_event) {
      const index = this.member_events.findIndex(item => item.member_event_id === member_event.member_event_id);

      if (index >= 0) {
        this.member_events[index] = member_event;
        this.member_events = [ ...this.member_events ];
      }

      // when event was changed
      if (this.local_item.event_id !== member_event.event_id) {
        this.member_events.splice(index, 1);
        this.member_events = [ ...this.member_events ];
      }

    },
    created_member_event(memberEvent) {

      this.member_events.unshift({ ...memberEvent,
        id: memberEvent.member_event_id,
        ts_signup: memberEvent.ts_signup,
        shop_order_id: memberEvent.shop_order_id,
        firstname: memberEvent.member ? memberEvent.member.firstname : memberEvent.person.firstname,
        lastname: memberEvent.member ? memberEvent.member.lastname : memberEvent.person.lastname,
        email: memberEvent.member ? memberEvent.member.email : memberEvent.person.email,
        telefon: memberEvent.member ? memberEvent.member.phone : memberEvent.person.phone,
        hantera: ''
      } );

      this.member_events = [ ...this.member_events ]

      this.toastr('success', this.$t('COMMON.OK'), this.$t('EVENT.MEMBER_PERSON_ADDED'));
    },

    async load_tickets(event_id) {
      try {
        const res = await axios.get(`/events/${event_id}/tickets`);
      
        if (res.status === 200) {
          this.ticket_options = res.data.map(i => ({ label: i.name, value: i.id }));
        }
      }
      catch (err) {
        console.error('load_tickets', err);
      }
      
    },

    tickets_changed() {},

    save_event() {},

    create_member_event_clicked() {
      this.member_event = {};

      this.$refs['member-event-editor-modal'].show();

    },

    async export_xlsx_clicked() {
      try {
        const res = await axios.post(`/member_event/xlsx/${this.local_item.event_id}`, {});

        if (res.status === 201) {
          downloadWithAxios(get_base_url() + `/dlfile/${res.data.linkstr}`, res.data.name);
        }
        else if (res.status === 403) {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.LACK_PERMISSION'));
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.FILES.UNABLE_CREATE_FILE'));
        }
      }
      catch (err) {
        console.error('export_xlsx_clicked error', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.FILES.UNABLE_CREATE_FILE'));
      }
      
    },

    async edit_member_event_clicked(member_event) {

      this.member_event = member_event;
      this.member_event_id = member_event.member_event_id;

      try {
        const res = await axios.get(`/member_event/${member_event.member_event_id}`);

        if (res.status === 200) {
          this.member_event = res.data;
          this.member_event_id = this.member_event.member_event_id;

          this.$refs['member-event-editor-modal'].show();

          return;
        }
      }
      catch (err) {
        console.error('load member event error', err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.UNABLE_LOAD_MEMBER_EVENT'));
    },
    
    async load_participants(event_id, tickets_filter) {
      if (!event_id) { return; }

      try {
        const res = await axios.get(`/member_event/participants?event_id=${event_id}`);
      
        if (res.status === 200) {
          this.member_events = res.data;

          if (Array.isArray(tickets_filter) && tickets_filter.length) {
            const allowedIds = new Set(tickets_filter);

            this.member_events = this.member_events.filter(ev =>
              Array.isArray(ev.tickets) &&
              ev.tickets.some(ticket => allowedIds.has(ticket.event_shop_item_id))
            );
          }

          let company_set = false;

          this.member_events = this.member_events.filter(item => item.person !== null || item.member !== null);

          for (let i = 0; i < this.member_events.length; ++i) {

            const m = this.member_events[i].person ? this.member_events[i].person : this.member_events[i].member;

            if (!company_set && this.member_events[i].company) {
              company_set = true;
            }
            this.member_events[i].search = (m.firstname+'').toLowerCase() + (m.lastname+'').toLowerCase() + m.personnr + m.in_personnr + m.phone + (m.email+'').toLowerCase();
          }

          if (!company_set) {
            this.event_headers = this.event_headers.filter(item => item.key !== 'company')
          }

          this.member_events_copy = this.member_events;
        }

      }
      catch (err) {
        console.error('load_particpants', err);
      }
      
    },

    delete_member_event_clicked(memberEvent) {
      this.member_event_to_delete = memberEvent;
      this.$refs['delete-member-event'].show();
    },

    async delete_member_event() {
      try {
        const member_event = this.member_event_to_delete;
        const res = await axios.delete(`/member_event/${member_event.member_event_id}`);
        
        if (res.status === 204) {
          this.member_events = this.member_events.filter(function(item) {
            return item.member_event_id !== member_event.member_event_id;
          });

          this.toastr('success', this.$t('COMMON.OK'), this.$t('EVENT.REMOVED_FROM_EVENT'));
          this.load_participants(this.item.event_id);
        } else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.UNABLE_REMOVE_PARTICIPANT'));
        }
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.UNABLE_REMOVE_PARTICIPANT'));
      }
    
    },
    
  }
}
</script>
<style scoped>
.empty-participant-message {
  text-align: center;
  padding: 4rem 1rem;
  background: #f9f9f9;
  border: 1px dashed #ccc;
  border-radius: 8px;
}

.big-icon {
  font-size: 4rem;
  color: #2D9BF0;
  margin-bottom: 1rem;
}

.info-text {
  font-size: 1.2rem;
  color: #555;
}
</style>